import { c as _c } from "react/compiler-runtime";
import React from "react";
import clsx from "clsx";
import type { ApiDropPart } from "@/generated/models/ApiDropPart";
import MediaDisplay from "@/components/drops/view/item/content/media/MediaDisplay";
import DropListItemContentMedia from "@/components/drops/view/item/content/media/DropListItemContentMedia";
import { ImageScale } from "@/helpers/image.helpers";
import WaveDropPartContentFullWidthImage from "./WaveDropPartContentFullWidthImage";
interface WaveDropPartContentMediasProps {
  readonly activePart: ApiDropPart;
  readonly disableMediaInteraction?: boolean | undefined;
  readonly isCompetitionDrop?: boolean | undefined;
  readonly imageScale?: ImageScale | undefined;
  readonly fullWidthMedia?: boolean | undefined;
}
const WaveDropPartContentMedias: React.FC<WaveDropPartContentMediasProps> = t0 => {
  const $ = _c(16);
  const {
    activePart,
    disableMediaInteraction: t1,
    isCompetitionDrop: t2,
    imageScale: t3,
    fullWidthMedia: t4
  } = t0;
  const disableMediaInteraction = t1 === undefined ? false : t1;
  const isCompetitionDrop = t2 === undefined ? false : t2;
  const imageScale = t3 === undefined ? ImageScale.AUTOx450 : t3;
  const fullWidthMedia = t4 === undefined ? false : t4;
  if (!activePart.media.length) {
    return null;
  }
  const hasContentBeforeMedia = Boolean(activePart.content?.trim()) || Boolean(activePart.quoted_drop?.drop_id);
  let topSpacingClassName = "tw-mt-1";
  if (hasContentBeforeMedia) {
    topSpacingClassName = "tw-mt-4";
  } else {
    if (fullWidthMedia) {
      topSpacingClassName = "tw-mt-0";
    }
  }
  let t5;
  if ($[0] !== topSpacingClassName) {
    t5 = clsx(topSpacingClassName, "tw-space-y-3");
    $[0] = topSpacingClassName;
    $[1] = t5;
  } else {
    t5 = $[1];
  }
  const mediaStackClassName = t5;
  let t6;
  if ($[2] !== activePart.media || $[3] !== disableMediaInteraction || $[4] !== fullWidthMedia || $[5] !== imageScale || $[6] !== isCompetitionDrop) {
    let t7;
    if ($[8] !== disableMediaInteraction || $[9] !== fullWidthMedia || $[10] !== imageScale || $[11] !== isCompetitionDrop) {
      t7 = (media, i) => {
        const useNaturalHeightImage = fullWidthMedia && media.mime_type.includes("image");
        const mediaContainerClassName = useNaturalHeightImage ? "tw-w-full" : clsx("tw-flex tw-h-64 tw-items-center tw-justify-center", fullWidthMedia && "tw-w-full");
        let mediaContent;
        if (disableMediaInteraction) {
          mediaContent = <MediaDisplay media_mime_type={media.mime_type} media_url={media.url} disableMediaInteraction={disableMediaInteraction} imageScale={imageScale} />;
        } else {
          if (useNaturalHeightImage) {
            mediaContent = <WaveDropPartContentFullWidthImage src={media.url} imageScale={imageScale} />;
          } else {
            mediaContent = <DropListItemContentMedia media_mime_type={media.mime_type} media_url={media.url} isCompetitionDrop={isCompetitionDrop} imageScale={imageScale} />;
          }
        }
        return <div key={`part-${i}-media-${media.url}`} className={mediaContainerClassName}>{mediaContent}</div>;
      };
      $[8] = disableMediaInteraction;
      $[9] = fullWidthMedia;
      $[10] = imageScale;
      $[11] = isCompetitionDrop;
      $[12] = t7;
    } else {
      t7 = $[12];
    }
    t6 = activePart.media.map(t7);
    $[2] = activePart.media;
    $[3] = disableMediaInteraction;
    $[4] = fullWidthMedia;
    $[5] = imageScale;
    $[6] = isCompetitionDrop;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[13] !== mediaStackClassName || $[14] !== t6) {
    t7 = <div className={mediaStackClassName}>{t6}</div>;
    $[13] = mediaStackClassName;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  return t7;
};
export default WaveDropPartContentMedias;